'use strict';
define(['xhr-promise', './util', './links/cookieService', './navigation/Breakpoint', './Constant'], function (XhrPromise, utils, mnsCookieService, breakpoint, constant) {

    /**
     * creates a new Search component.
     * @constructor
     * @param {Object} params - searchContainer & searchCommand
     */
    var RECENT_SEARCHES = 'Your recent searches',
        CLEAR = 'Clear',
        CLR_RECENT_SEARCHES = 'Clear',
        TAB_768 = 768,
        TAB_767 = 767,
        MAX_RECENT_SEARCH = 3;


    function Search(params) {
        this.options = params;
    }

    Search.prototype = {

        /**
         * initialize Search Component
         */
        init: function (storeId) {
            var pageFeature = document.getElementById('featureData') ? document.getElementById('featureData').innerText : false;
            this.pageType = document.getElementById('pageType') ? document.getElementById('pageType').innerText : false;
            this.currentStoreId = storeId;
            this.searchContainer = this.options.searchContainer;
            this.searchOverlayBackground = this.options.navVeil;
            this.command = this.options.command;
            this.localStorage = this.options.localStorage || window.localStorage;
            this.wrapperGenerated = false;
            this.searchBar = this.searchContainer.querySelector('.navigation-search-bar--search');
            this.searchContainerParentOverlay = this.options.searchContainerParentOverlay;
            this.mobileSearchbarReset = this.searchContainerParentOverlay.querySelector('.navigation-dock-search-popup .navigation-search-bar--search');
            this.searchBox = this.searchContainerParentOverlay.querySelector('.navigation-dock-search-popup');
            this.resetPaddingTop = this.searchContainerParentOverlay.querySelector('.navigation-search-bar--suggestion-dropdown');
            this.clearTextSearchOverlay = this.searchContainerParentOverlay.querySelector('.navigation-res-nav-header__dropdown--search .navigation-hdr-search-bar--clear');
            this.closeSearchOverlayButton = this.searchContainerParentOverlay.querySelector('.navigation-res-nav-header__dropdown--search .navigation-search-bar--clear');
            this.overlaySearchInput = this.searchContainerParentOverlay.querySelector('#overlaysearch');
            if (document.getElementById('navigation-dummySearch') && document.getElementById('navigation-dummySearch').hasAttribute('placeholder')) {
                this.inputPlaceholder = document.getElementById('navigation-dummySearch').getAttribute('placeholder');
            }
            this.bodyEl = document.querySelector('body');
            this.headerEl = document.querySelector('.navigation-common-hdr-main');
            this.skipacc = document.querySelector('.navigation-temp-search-acc');
            this.dummySearchPanel = document.querySelector('.navigation-dropdown__panel--search');
            pageFeature = (pageFeature && this.pageType) ? JSON.parse('{' + pageFeature + '"default":{}}') : false;
            var mobileSearchKey = (pageFeature && pageFeature[this.pageType]) ? pageFeature[this.pageType].mobileSearchExposed : false;
            window.mobileSearchKey = mobileSearchKey;
            this.topNavCheckBox = document.querySelectorAll('.navigation-dropdown__checkbox');
            this.searchButton = this.options.searchButton;
            this.stickySearch = this.stickySearch.bind(this);
            this.submitButton = this.searchContainer.querySelector('.navigation-res-nav-header__dropdown--search .navigation-search-bar--submit');
            this.submitButton.disabled = true;

            this.closeSuggestions = this.closeSuggestions.bind(this);
            this.searchInputKeyUpHandler = this.searchInputKeyUpHandler.bind(this);
            this.searchFormSubmitHandler = this.searchFormSubmitHandler.bind(this);
            this.openSuggestions = this.openSuggestions.bind(this);
            this.resetSuggestions = this.resetSuggestions.bind(this);
            this.resetSearchText = this.resetSearchText.bind(this);
            this.setValueSearchOverlayInput = this.setValueSearchOverlayInput.bind(this);
            this.removeHeight = this.removeHeight.bind(this);
            this.setPaddingTop = this.setPaddingTop.bind(this);
            this.showPopup = this.showPopup.bind(this);
            this.checkRecentelement = this.checkRecentelement.bind(this);
            this.hidePopup = this.hidePopup.bind(this);
            this.searchOverlayBackgroundClick = this.searchOverlayBackgroundClick.bind(this);
            this.clearTextSearchOverlayClick = this.clearTextSearchOverlayClick.bind(this);
            this.closeSearchOverlayButtonClick = this.closeSearchOverlayButtonClick.bind(this);
            this.stopKeyStrockTracking = this.stopKeyStrockTracking.bind(this);
            this.dummySearchPanelClick = this.dummySearchPanelClick.bind(this);
            this.dummySearchPanelKeyUp = this.dummySearchPanelKeyUp.bind(this);
            this.searchButtonClick = this.searchButtonClick.bind(this);
            this.searchBarFocus = this.searchBarFocus.bind(this);
            this.searchOverlayKeyUp = this.searchOverlayKeyUp.bind(this);
            this.debounce = this.debounce.bind(this);
            this.suggestionsCoordinator = this.suggestionsCoordinator.bind(this);
            this.searchAccClose = this.searchAccClose.bind(this);
            this.form = this.searchContainer.querySelector('form');
            this.formParams = this.getFormParams();
            this.formParams.q = '';

            this.utils = utils;

            if (breakpoint.size() === 'xsmall') {
                document.querySelector('.navigation-btn__icon--search').innerText = '';
                document.querySelector('.navigation-header__title-text__desktop').innerText = '';
                var userAgent = window.navigator.userAgent || window.navigator.vendor || window.opera;
                var dummySearchBar = document.querySelector('.navigation-res-nav-header__search .navigation-search-bar--search-wrap');
                if (/iPad/.test(userAgent) && (window.innerWidth === TAB_768) || (window.innerWidth === TAB_767)) {
                    window.mobileSearchKey = mobileSearchKey;
                    document.querySelector('.navigation-res-nav-header__search').style.display = 'block';
                    this.searchButton.style.display = 'none';
                    document.querySelector('.navigation-btn__icon--search-container').style.display = 'none';
                    dummySearchBar = document.querySelector('.navigation-res-nav-header__search .navigation-search-bar--search-wrap');
                    utils.addClass(dummySearchBar, 'navigation-search-bar--search-wrap__full-width');
                    var headerSectionLogo = document.querySelector('.navigation-logo');
                    var headerSection = document.getElementById('progressiveHeaderSection');
                    utils.addClass(headerSectionLogo, 'navigation-logo-ipad-portrait');

                    utils.addClass(this.dummySearchPanel, 'navigation-search-bar-ipad-portrait');
                    var searchPanelWarp = document.querySelector('.navigation-res-nav-header__search .navigation-search-bar--search-wrap');
                    utils.addClass(searchPanelWarp, 'navigation-search-warp-ipad-portrait');

                    var ipadMenu = document.querySelector('.navigation-hamburger-trigger');
                    utils.addClass(ipadMenu, 'navigation-hamburger-ipad-portrait');
                    utils.addClass(headerSection, 'navigation-header-ipad-height');
                } else if (mobileSearchKey) { //collapsed
                    window.mobileSearchKey = mobileSearchKey;
                    document.querySelector('.navigation-res-nav-header__search').style.display = 'none';
                    this.searchButton.style.display = 'block';
                    this.dummySearchPanel.style.display = 'none';
                } else { //collapsed
                    document.querySelector('.navigation-res-nav-header__search').style.display = 'block';
                    this.searchButton.style.display = 'none';
                    this.dummySearchPanel.style.display = 'block';
                    document.querySelector('.navigation-btn__icon--search-container').style.display = 'none';
                    dummySearchBar = document.querySelector('.navigation-res-nav-header__search .navigation-search-bar--search-wrap');
                    utils.addClass(dummySearchBar, 'navigation-search-bar--search-wrap__full-width');
                }
            } else {
                this.searchButton.removeAttribute('style');
                this.dummySearchPanel.removeAttribute('style');
            }

            this.bindEvents();
            this.generateWrapper();
        },

        /**
         * bind events with search input box & document
         */
        bindEvents: function () {
            this.searchOverlayBackground.addEventListener('click', this.searchOverlayBackgroundClick);
            this.clearTextSearchOverlay.addEventListener('click', this.clearTextSearchOverlayClick);
            this.closeSearchOverlayButton.addEventListener('click', this.closeSearchOverlayButtonClick);
            this.closeSearchOverlayButton.addEventListener('mouseover', this.stopKeyStrockTracking);
            this.closeSearchOverlayButton.addEventListener('touchstart', this.stopKeyStrockTracking);

            this.dummySearchPanel.addEventListener('click', this.dummySearchPanelClick);
            this.dummySearchPanel.addEventListener('keyup', this.dummySearchPanelKeyUp);
            this.searchButton.addEventListener('click', this.searchButtonClick);
            this.form.addEventListener('submit', this.searchFormSubmitHandler);
            this.searchBar.addEventListener('focus', this.searchBarFocus);
            this.searchContainerParentOverlay.addEventListener('keyup', this.searchOverlayKeyUp);
            var debouncedKeyUp = this.debounce(this.suggestionsCoordinator, 200);
            this.searchBar.addEventListener('keyup', this.searchInputKeyUpHandler);
            this.searchBar.addEventListener('paste', this.searchInputKeyUpHandler);
            this.searchBar.addEventListener('input', debouncedKeyUp);
            if (this.skipacc) {
                this.skipacc.addEventListener('focus', this.searchAccClose);
            }
        },

        debounce: function (func, delay) {
            var debounceTimer;
            return function () {
                var context = this,
                    args = arguments;
                clearTimeout(debounceTimer);
                debounceTimer = setTimeout(function () {
                    func.apply(context, args);
                }, delay);
            };
        },
        /**
         * Reset Searchbar text
         */
        resetSearchText: function () {
            document.querySelector('.navigation-res-nav-header__dropdown--search .navigation-search-bar--search').value = '';
            if (breakpoint.size() === 'xsmall') {
                document.querySelector('.navigation-dock-search-popup').classList.remove('navigation-hdr-sticky-class');
            }
        },
        /**
         * Creates search suggestions and opens/closes the list
         */
        suggestionsCoordinator: function () {
            var createSuggestions = this.createSuggestions.bind(this);
            this.fetchSuggestions(createSuggestions);
        },
        /**
         * Resets suggestions in the overlay
         */
        resetSuggestions: function (event) {
            this.suggestionsCoordinator();
            event.stopPropagation();
        },
        /**
         * keyUp handler for search input box
         */
        searchInputKeyUpHandler: function (event) {

            if (event.target.value.trim().length > 0) {
                if (breakpoint.size() === 'xsmall') {
                    this.clearTextSearchOverlay.style.display = 'block';
                }
                else {
                    this.clearTextSearchOverlay.style.display = 'none';
                }
            } else {
                event.target.value = '';
                this.clearTextSearchOverlay.removeAttribute('style');
            }

            if (event.target.value.trim().length > 1) {
                this.enableSubmit();
            } else {
                this.disableSubmit();
            }

            if (event.type === 'paste') {
                this.enableSubmit();
                this.formParams.q = event.clipboardData.getData('Text');
                this.suggestionsCoordinator();
            }

            if (event.shiftKey === false) {
                this.formParams.q = event.target.value;

                var keyPressed = event.key || event.keyCode;

                if (keyPressed === 27 || keyPressed === 38 || keyPressed === 39 || keyPressed === 40 || keyPressed === 'Esc' || keyPressed === 'Escape' || keyPressed === 'ArrowUp' || keyPressed === 'ArrowDown' || keyPressed === 'ArrowRight') {
                    this.keyboardNavigateSuggestions(keyPressed, event);
                }
            }
            if (breakpoint.size() === 'xsmall') {
                if ((this.mobileSearchbarReset.value === '') && (this.searchBox.classList.contains('navigation-hdr-sticky-class'))) {
                    this.searchBox.classList.remove('navigation-hdr-sticky-class');
                    this.removeHeight();
                    this.resetPaddingTop.classList.remove('navigation-suggestion-list-padding');

                }
            }
        },

        /**
         * navigate search suggestions using up/down/right arrows
         */
        keyboardNavigateSuggestions: function (keyPressed, event) {
            this.suggestionList = this.searchContainer.getElementsByClassName('navigation-search-bar__suggestion-list')[0];

            if (this.suggestionList) {
                var selectedSuggestion = this.suggestionList.getElementsByClassName('selected')[0],
                    allSuggestions = this.suggestionList.getElementsByClassName('suggestion-item'),
                    firstSuggestion = allSuggestions[0],
                    lastSuggestion = allSuggestions[allSuggestions.length - 1],
                    selectedSuggestionId;
            }

            switch (keyPressed) {
                case 'ArrowUp': // up
                case 38:
                    event.stopPropagation();

                    if (selectedSuggestion) {
                        utils.removeClass(selectedSuggestion, 'selected');

                        selectedSuggestionId = Array.prototype.indexOf.call(allSuggestions, selectedSuggestion);
                        var prevSuggestion = allSuggestions[selectedSuggestionId - 1];

                        if (prevSuggestion) {
                            this.highlightSuggestion(prevSuggestion);
                        } else {
                            this.highlightSuggestion(lastSuggestion);
                        }
                    } else {
                        this.highlightSuggestion(lastSuggestion);
                    }

                    break;
                case 'ArrowDown': // down
                case 40:
                    event.stopPropagation();

                    if (selectedSuggestion) {
                        utils.removeClass(selectedSuggestion, 'selected');

                        selectedSuggestionId = Array.prototype.indexOf.call(allSuggestions, selectedSuggestion);
                        var nextSuggestion = allSuggestions[selectedSuggestionId + 1];

                        if (nextSuggestion) {
                            this.highlightSuggestion(nextSuggestion);
                        } else {
                            this.highlightSuggestion(firstSuggestion);
                        }
                    } else {
                        this.highlightSuggestion(firstSuggestion);
                    }
                    break;
                case 'ArrowRight': // right
                case 39:
                    if (selectedSuggestion) {
                        if (!utils.hasClass(selectedSuggestion, 'navigation-suggestion-item--clear')) {
                            this.setRecentSearches(selectedSuggestion.querySelector('a').dataset.keyword);
                            window.location.href = selectedSuggestion.querySelector('a');
                        }
                    }
                    break;
                case 'Escape': // right
                case 27:
                    this.hidePopup();
                    break;
            }
        },

        /**
         * highlight particular item in the suggestion list if it is visible
         */
        highlightSuggestion: function (item) {
            if (!utils.hasClass(this.wrapper, 'navigation-search-bar--suggestion-dropdown__hidden')) {
                utils.addClass(item, 'selected');

                var itemText = item.querySelector('a');
                if (itemText) {
                    this.searchBar.value = item.querySelector('a').dataset.keyword;
                }
            }
        },

        // add hidden input element for user segment
        addHidden: function (theForm, key, value) {
            var input = document.createElement('input');
            input.type = 'hidden';
            input.name = key; // 'the key/name of the attribute/field that is sent to the server
            input.value = value;
            theForm.appendChild(input);
        },

        /*
         * To check below conditions before appending usg to URL
         * switch is enabled
         * user logged in
         * user segment cookie is not default
         * search term is present in segments stored in local storage
         */
        checkUSG: function (searchTerm) {
            var localStorageTerms = this.localStorage.getItem('userSegmentSearch');
            var searchTerms = [];
            if (localStorageTerms) {
                searchTerms = localStorageTerms.split(',');
            }
            if (mnsCookieService.isUserLoggedIn() && mnsCookieService.getUserSegmentCookieValue() !== 'default' && searchTerms.indexOf(searchTerm) > -1) {
                return true;
            }
            return false;
        },

        /**
         * submit handler for search form - if form submitted with selected suggestion
         */
        searchFormSubmitHandler: function (event) {
            var theForm = document.forms.productSearch;
            var searchTermNoTrim = theForm.searchTerm.value;
            var searchTerm = searchTermNoTrim.trim().replace(/[%><^[\],.()=]+/g, '');
            theForm.searchTerm.value = searchTerm;
            var usg = this.checkUSG(searchTerm);
            if (usg) {
                this.addHidden(theForm, 'usg', mnsCookieService.getUserSegmentCookieValue());
            }
            if (this.suggestionList) {
                var selectedSuggestion = this.suggestionList.getElementsByClassName('selected')[0];
                if (selectedSuggestion) {
                    event.preventDefault();
                    if (utils.hasClass(selectedSuggestion, 'navigation-suggestion-item--clear')) {
                        this.clearRecentSearches(event);
                    } else {
                        this.setRecentSearches(selectedSuggestion.querySelector('a').dataset.keyword);
                        window.location.href = selectedSuggestion.querySelector('a');
                    }
                }
            } else {
                this.setRecentSearches(searchTerm);
            }
            this.setValueSearchOverlayInput();
        },

        /**
         * set value in input serach overlay text
         */
        setValueSearchOverlayInput: function () {
            //hide placeholder on setting value
            var elInput = this.searchBar.value;
            var elInputSearchOverlay = this.searchContainerParentOverlay.querySelector('.navigation-res-nav-header__dropdown--search .navigation-search-bar--search');

            if (elInput) {
                elInputSearchOverlay.value = elInput;
            }
        },

        /**
         * close suggestion box on click
         */
        closeSuggestions: function () {
            var _this = this;
            if (_this.wrapper) {
                _this.utils.addClass(_this.wrapper, 'navigation-search-bar--suggestion-dropdown__hidden');
            }
        },

        /**
         * show searchbox popup
         */
        checkRecentelement: function () {
            var recentElement = document.querySelector('.navigation-suggestion-item--title');
            if (recentElement && !recentElement.hasAttribute('style')) {
                var recentSearchList = document.querySelector('.navigation-recentsearch--list');
                recentSearchList.style.maxHeight = '1000px';
                recentSearchList.style.opacity = 1;
                recentElement.style.maxHeight = '1000px';
                recentElement.style.opacity = 1;
                clearInterval(this.checkRecTimer);
            }
        },
        showPopup: function () {
            this.searchContainerParentOverlay.querySelector('.navigation-res-nav-header__dropdown--search .navigation-search-bar--search').focus();
            this.utils.removeClass(this.searchContainerParentOverlay, 'navigation-search-overlay-hidden');
            this.utils.addClass(this.searchOverlayBackground, 'navigation-is-active-prompt');

            this.skipacc.tabIndex = 0;
            if (breakpoint.size() === 'medium' || breakpoint.size() === 'large') {
                this.checkRecTimer = setInterval(this.checkRecentelement, 100);
                var recentElementTitle = document.querySelector('.navigation-suggestion-item--title');
                if (recentElementTitle) {
                    var recentSearchListItems = document.querySelector('.navigation-recentsearch--list');
                    recentSearchListItems.style.maxHeight = '1000px';
                    recentSearchListItems.style.opacity = 1;
                    recentElementTitle.style.maxHeight = '1000px';
                    recentElementTitle.style.opacity = 1;
                }
            }

            if (breakpoint.size() === 'xsmall') {
                this.headerEl.style.zIndex = '2147483649';
                if (this.utils.hasClass(document.getElementById('common-hdr-main'), 'navigation-sticky')) {
                    this.utils.addClass(this.bodyEl, 'navigation-prevent-stickyscrolling');
                    this.utils.addClass(document.querySelector('html'), 'navigation-prevent-stickyscrolling');
                } else {
                    this.utils.addClass(this.bodyEl, 'navigation-prevent-scrolling');
                }
            }
            if (document.querySelector('.navigation-dock-search-popup .navigation-search-bar--search')) {
                document.querySelector('.navigation-dock-search-popup .navigation-search-bar--search').tabIndex = '0';
            }
            if (document.querySelector('.navigation-suggestion-item--title')) {
                document.querySelector('.navigation-suggestion-item--title').tabIndex = '0';
            }
            if (document.querySelector('.navigation-suggestion-item--clear-text')) {
                document.querySelector('.navigation-suggestion-item--clear-text').tabIndex = '0';
            }
        },
        /**
         * hide searchbox popup
         */
        hidePopup: function () {
            this.utils.addClass(this.searchContainerParentOverlay, 'navigation-search-overlay-hidden');
            this.utils.removeClass(this.searchOverlayBackground, 'navigation-is-active-prompt');
            this.skipacc.tabIndex = -1;
            if (breakpoint.size() === 'xsmall') {
                this.headerEl.style.zIndex = '15';
                this.utils.removeClass(this.bodyEl, 'navigation-prevent-stickyscrolling');
                this.utils.removeClass(document.querySelector('html'), 'navigation-prevent-stickyscrolling');
                this.utils.removeClass(this.bodyEl, 'navigation-prevent-scrolling');
            }
            if (document.querySelector('.navigation-dock-search-popup .navigation-search-bar--search')) {
                document.querySelector('.navigation-dock-search-popup .navigation-search-bar--search').tabIndex = '-1';
            }
            if (document.querySelector('.navigation-dock-search-popup .navigation-search-bar--clear')) {
                document.querySelector('.navigation-dock-search-popup .navigation-search-bar--clear').tabIndex = '-1';
            }
            if (document.querySelector('.navigation-suggestion-item--title')) {
                document.querySelector('.navigation-suggestion-item--title').tabIndex = '-1';
            }
            if (document.querySelector('.navigation-suggestion-item--clear-text')) {
                document.querySelector('.navigation-suggestion-item--clear-text').tabIndex = '-1';
            }
            var recentElement = document.querySelector('.navigation-suggestion-item--title');
            if (breakpoint.size() === 'medium' || breakpoint.size() === 'large') {
                if (recentElement) {
                    var recentSearchList = document.querySelector('.navigation-recentsearch--list');
                    recentSearchList.style.maxHeight = '0';
                    recentSearchList.style.opacity = 0;
                    recentElement.style.maxHeight = '0';
                    recentElement.style.opacity = 0;
                }
            }
        },
        /**
         * open suggestion box on search input box focus
         */
        openSuggestions: function () {
            if (this.wrapper) {
                this.utils.removeClass(this.wrapper, 'navigation-search-bar--suggestion-dropdown__hidden');
                this.headerSearchTypeRecent = document.querySelector('.reSearchHeader');
                if (this.pageDiv && this.utils.hasClass(this.pageDiv, 'navigation-is-active-acc')) {
                    this.utils.removeClass(this.myAccountContainer, 'navigation-header__sub-list-container--signacc-displayblock');
                    this.utils.removeClass(this.pageDiv, 'navigation-is-active-acc');
                    this.utils.removeClass(this.pageDivBorder, 'navigation-is-active');
                    this.myAccButton.style.boxShadow = 'none';
                }
            }
        },

        /**
         * generate wrapper around suggestion list
         */
        generateWrapper: function () {
            this.wrapper = this.searchContainerParentOverlay.querySelector('.navigation-search-bar--suggestion-dropdown.navigation-search-bar--suggestion-dropdown__hidden');
            this.SearchdropdownDiv = document.createElement('div');
            this.SearchdropdownDiv.className = 'navigation-search-bar--dropdowndiv';
            this.ul = document.createElement('ul');
            this.recentSearchDiv = document.createElement('div');
            this.recentsearchul = document.createElement('ul');
            this.recentsearchul.className = 'navigation-search-bar__suggestion-list';
            this.utils.addClass(this.recentsearchul, 'navigation-recentsearch--list');
            this.ul.className = 'navigation-search-bar__suggestion-list';
            this.utils.addClass(this.ul, 'navigation-search-item--list');
            this.wrapper.appendChild(this.SearchdropdownDiv);
            this.SearchdropdownDiv.appendChild(this.ul);
            this.SearchdropdownDiv.appendChild(this.recentSearchDiv);
            this.SearchdropdownDiv.appendChild(this.recentsearchul);
            this.wrapperGenerated = true;
            if (breakpoint.size() === 'xsmall') {
                document.querySelector('.navigation-search-bar--suggestion-dropdown').addEventListener('touchstart', this.stickySearch);
            }
        },

        appendUSG: function (data) {
            var splitLink = data.split('"');
            var usg = this.checkUSG(splitLink[3]);
            if (usg) {
                splitLink[1] = splitLink[1] + '&usg=' + mnsCookieService.getUserSegmentCookieValue();
            }
            data = splitLink.join('"');
            return data;
        },

        /**
         * create suggestion list
         * @param {Array} data suggestion list
         */
        createSuggestions: function (data) {
            this.ul.innerHTML = '';

            if (data.length > 0) {
                var rows = data.length < 10 ? data.length : 10;
                for (var x = 0; x < rows; x++) {
                    if (data[x]) {
                        data[x] = this.appendUSG(data[x]);
                        this.ul.appendChild(this.createSuggestionItem(data[x]));
                    }
                }
            }
            if (!document.querySelector('.navigation-suggestion-item--title')) {
                this.addRecentSearchSuggestions();
            }
            this.setCategorySection();
            this.openSuggestions();

            if (breakpoint.size() === 'small' || breakpoint.size() === 'medium' || breakpoint.size() === 'large') {
                var recentElement = document.querySelector('.navigation-suggestion-item--title'),
                    suggestionListArray = document.querySelectorAll('.navigation-search-item--list li.suggestion-item'),
                    suggestionList = document.querySelector('.navigation-search-item--list');
                if (suggestionListArray.length !== 0) {
                    if (recentElement) {
                        this.utils.addClass(suggestionList, 'navigation-recent-serach-underline');
                    }
                } else if (suggestionListArray.length === 0) {
                    if (recentElement) {
                        this.utils.removeClass(suggestionList, 'navigation-recent-serach-underline');
                    }
                }
            }
        },

        /**
         *  Add class to last suggestion in category
         */
        setCategorySection: function () {
            var allSuggestions = this.searchContainer.getElementsByClassName('suggestion-item'),
                lastCategoryIndex;

            for (var i = 0; i < allSuggestions.length; i++) {
                var suggestionLink = allSuggestions[i].firstChild;

                if (suggestionLink && suggestionLink.nodeName === 'A' && suggestionLink.getAttribute('href').indexOf('categoryTypeAhead') !== -1) {
                    lastCategoryIndex = i;
                }
            }

            if (lastCategoryIndex) {
                utils.addClass(allSuggestions[lastCategoryIndex], 'suggestion-item--category');
            }
        },

        /**
         * Add recent searches to the suggestions list
         */
        addRecentSearchSuggestions: function () {
            var recentSearches = this.getRecentSearches();

            if (recentSearches.length === 0) {
                return;
            }

            var recentSearchLinks = this.createRecentSearchLinks(recentSearches);
            var recentSearchBold = document.createElement('b');
            this.recentSearchDiv.appendChild(recentSearchBold);
            recentSearchBold.innerHTML = RECENT_SEARCHES;
            this.recentSearchDiv.tabIndex = '-1';
            this.utils.addClass(this.recentSearchDiv, 'navigation-suggestion-item--title');

            if (breakpoint.size() === 'medium' || breakpoint.size() === 'large') {
                var recentElement = document.querySelector('.navigation-suggestion-item--title'),
                    suggestionListArray = document.querySelectorAll('.navigation-search-bar__suggestion-list li'),
                    suggestionList = document.querySelector('.navigation-search-item--list');
                if (suggestionListArray.length !== 0) {
                    if (recentElement) {
                        this.utils.addClass(suggestionList, 'navigation-recent-serach-underline');
                    }
                }
            }

            for (var x = 0; x < recentSearchLinks.length; x++) {
                var splitLink = recentSearchLinks[x].split('"');
                var usg = this.checkUSG(splitLink[3]);
                if (usg) {
                    splitLink[1] = splitLink[1] + '&usg=' + mnsCookieService.getUserSegmentCookieValue();
                }
                recentSearchLinks[x] = splitLink.join('"');
                var el = this.createSuggestionItem(recentSearchLinks[x]);
                this.utils.addClass(el, 'navigation-suggestion-item--recent');
                this.recentsearchul.appendChild(el);
            }
            var clearElement = document.createElement('div');
            var recentSearchElement = document.querySelector('.navigation-suggestion-item--title'),
                clearElementdevice = document.createElement('span'),
                clearRecentSearches = this.clearRecentSearches.bind(this),
                clearElementdeviceClick = this.clearElementdeviceClick.bind(this),
                clearElementdeviceKeyUp = this.clearElementdeviceKeyUp.bind(this);
            if (breakpoint.size() === 'xsmall') {
                if (recentSearchElement) {
                    clearElementdevice.innerHTML = CLEAR;
                    this.utils.addClass(clearElementdevice, 'suggestion-item');
                    this.utils.addClass(clearElementdevice, 'navigation-suggestion-item--clear');
                    clearElementdevice.addEventListener('click', clearRecentSearches);
                    recentSearchElement.appendChild(clearElementdevice);
                }
            } else {
                clearElementdevice.addEventListener('click', clearElementdeviceClick);
                clearElementdevice.addEventListener('keyup', clearElementdeviceKeyUp);
                clearElementdevice.tabIndex = '-1';
                clearElementdevice.setAttribute('aria-label', CLR_RECENT_SEARCHES);
                if (breakpoint.size() === 'small' || breakpoint.size() === 'medium' || breakpoint.size() === 'large') {
                    clearElementdevice.innerHTML = CLEAR;
                }
                this.utils.addClass(clearElementdevice, 'navigation-suggestion-item--clear-text');
                this.utils.addClass(clearElement, 'suggestion-item');
                this.utils.addClass(clearElement, 'navigation-suggestion-item--clear');
                clearElement.appendChild(clearElementdevice);
                this.recentsearchul.appendChild(clearElement);
                var recentSearchLength = document.querySelectorAll('.suggestion-item.navigation-suggestion-item--recent').length;
                if ((breakpoint.size() === 'medium' || breakpoint.size() === 'large')) {
                    if (recentSearchLength === 1) {
                        clearElement.style.top = '-7.8rem';
                    } else if (recentSearchLength === 2) {
                        clearElement.style.top = '-11.5rem';
                    }
                    else if (recentSearchLength === 3) {
                        clearElement.style.top = '-15.2rem';
                    }
                }
                else if (breakpoint.size() === 'small') {
                    if (recentSearchLength === 1) {
                        clearElement.style.top = '-7.8rem';
                    }
                    else if (recentSearchLength === 2) {
                        clearElement.style.top = '-12.3rem';
                    }
                    else if (recentSearchLength === 3) {
                        clearElement.style.top = '-16.8rem';
                    }
                }
            }
        },
        /**
         * Return true if suggestions list is empty
         */
        checkSuggestionsListEmpty: function () {
            return this.ul.childNodes.length === 0;
        },

        /**
         * Create <a> link elements for recent search suggestion items
         */
        createRecentSearchLinks: function (searchTerms) {
            var searchLinks = [],
                formParams = JSON.parse(JSON.stringify(this.formParams)),
                searchCommand = (this.currentStoreId === constant.ieId) ? constant.ieSearch : constant.ukSearch;

            delete formParams.typeAhead;
            delete formParams.q;
            delete formParams.intid;

            for (var x = 0; x < searchTerms.length; x++) {
                formParams.searchTerm = searchTerms[x];
                var url = [searchCommand, this.utils.serialize(formParams)].join('?');
                var aTag = document.createElement('a');
                aTag.setAttribute('href', url);
                aTag.setAttribute('class', 'reSearchHeader');
                aTag.setAttribute('data-keyword', searchTerms[x]);
                aTag.text = searchTerms[x];
                searchLinks.push(aTag.outerHTML);
            }
            return searchLinks;
        },

        /**
         * Get recent searches from local storage and format
         * @returns Array
         */
        getRecentSearches: function () {
            var myRecentSearchItem = this.localStorage.getItem('myRecentSearch');

            if (!myRecentSearchItem) {
                return [];
            }

            return myRecentSearchItem.split('||');
        },

        /**
         * Set recent searches in local storage in correct format
         */
        setRecentSearches: function (searchTerm) {
            var recentSearches = this.getRecentSearches();

            if (recentSearches.indexOf(searchTerm) > -1) {
                recentSearches.splice(recentSearches.indexOf(searchTerm), 1);
            }

            recentSearches.unshift(searchTerm);
            if (recentSearches.length > MAX_RECENT_SEARCH) {
                recentSearches.pop();
            }

            this.localStorage.setItem('myRecentSearch', recentSearches.join('||'));
        },

        /**
         * Clear the recent searches in local storage
         */
        clearRecentSearches: function (evt) {
            if (evt) {
                evt.stopPropagation();
                evt.preventDefault();
            }
            this.localStorage.removeItem('myRecentSearch');
            var el = this.searchContainerParentOverlay.querySelector('.navigation-search-bar__suggestion-list.navigation-recentsearch--list');
            var recentSearchTitle = document.querySelector('.navigation-suggestion-item--title');
            var clearRecentSearch = document.querySelector('.navigation-suggestion-item--clear');
            var _this = this;
            if (recentSearchTitle) {
                recentSearchTitle.innerHTML = '';
                this.utils.removeClass(recentSearchTitle, 'navigation-suggestion-item--title');
            }
            if ((breakpoint.size() !== 'small' || breakpoint.size() !== 'xsmall') && document.querySelector('.navigation-suggestion-item--clear')) {
                clearRecentSearch.parentNode.removeChild(clearRecentSearch);
            }
            var recentSearchElArr = this.searchContainerParentOverlay.querySelectorAll('.navigation-suggestion-item--recent');
            for (var i = 0; i < recentSearchElArr.length; i++) {
                el.removeChild(recentSearchElArr[i]);
            }
            if (breakpoint.size() === 'xsmall') {
                var recentElement = document.querySelector('.navigation-suggestion-item--title'),
                    suggestionListArray = document.querySelectorAll('.navigation-search-bar__suggestion-list li');
                if (suggestionListArray.length !== 0) {
                    if (!recentElement) {
                        document.querySelector('.navigation-search-bar__suggestion-list').style.height = '100' + 'vh';
                    }
                }
            }
            var suggestionList = document.querySelector('.navigation-search-item--list');
            if (breakpoint.size() === 'medium' || breakpoint.size() === 'large') {
                this.utils.removeClass(suggestionList, 'navigation-recent-serach-underline');
            }
            _this.searchContainerParentOverlay.querySelector('.navigation-res-nav-header__dropdown--search .navigation-search-bar--search').focus();
        },
        /**
         * create single suggestion item, append item to list, bind click event to item
         * @param {String} suggestion item
         * @returns {Element} single suggestion element
         */
        createSuggestionItem: function (item) {
            var listItem,
                selectSuggestion = this.selectSuggestion.bind(this);

            listItem = document.createElement('li');
            listItem.className = 'suggestion-item';
            listItem.tabIndex = -1;

            listItem.innerHTML = item;

            listItem.addEventListener('click', selectSuggestion);

            return listItem;
        },

        /**
         * update search input box value based on selected suggestion
         */
        selectSuggestion: function (event) {
            this.searchBar.value = event.currentTarget.textContent;
            this.setRecentSearches(this.searchBar.value);
            var el = this.searchContainerParentOverlay.querySelector('.navigation-search-bar__suggestion-list.navigation-recentsearch--list');
            var recentSearchTitle = this.searchContainerParentOverlay.querySelector('.navigation-suggestion-item--title');
            el.innerHTML = '';
            recentSearchTitle.innerHTML = '';
            this.addRecentSearchSuggestions();
        },

        /**
         * enable search submit button
         */
        enableSubmit: function () {
            this.submitButton.disabled = false;
        },

        /**
         * disable search submit button
         */
        disableSubmit: function () {
            this.submitButton.disabled = true;
        },

        /**
         * make ajax call for fetching suggestion list based on search input box value
         */
        fetchSuggestions: function (callback) {
            window.sessionStorage.setItem('searchCharCount',this.formParams.q.length);
            window.sessionStorage.setItem('searchChar',this.formParams.q);
            if (this.formParams.q.length === 0) {
                if (this.searchOverlayVsMessageEl) {
                    this.utils.removeClass(this.searchOverlayVsMessageEl, 'navigation-searchoverlay-vs--prompt--hidden');
                }
                callback([]);
            } else if (this.formParams.q.length === 1) {
                if (this.searchOverlayVsMessageEl) {
                    this.utils.addClass(this.searchOverlayVsMessageEl, 'navigation-searchoverlay-vs--prompt--hidden');
                }
                callback([]);
            } else if (this.formParams.q.length < 2) {
                callback([]);
            } else {
                var self = this;
                var xhrp = new XhrPromise();

                xhrp.send({
                    url: self.getSuggestionsUrl(),
                    method: 'GET'
                })
                    .then(function (response) {
                        if (response.status === 200) {
                            callback(response.responseText);
                        }
                    })
                    .catch(function () {
                        //Handle errors here
                        callback([]);
                    });
            }
        },

        /**
         * @returns {string} url with form get params
         */
        getSuggestionsUrl: function () {
            /**Test for XSS issue**/
            this.formParams.q = this.formParams.q.replace(/[%><^[\],.()=]+/g, '');
            var url = [this.command, this.utils.serialize(this.formParams)];
            return url.join('?');
        },

        /**
         * convert search form elements into object
         * @returns {Object} search form elements
         */
        getFormParams: function () {
            var searchForm = this.searchContainer.querySelector('form[name="productSearch"]');
            searchForm.action = (this.currentStoreId === constant.ieId) ? constant.ieSearch : constant.ukSearch;
            var formValues = {};

            for (var i = 0, n = searchForm.length; i < n; i++) {
                var e = searchForm.elements[i];
                if (e.name) {
                    formValues[e.name] = e.value;
                }
            }

            delete formValues.searchTerm;

            return formValues;
        },

        stickySearch: function () {
            if (this.mobileSearchbarReset.value !== '') {
                document.querySelector('.navigation-dock-search-popup').classList.add('navigation-hdr-sticky-class');
                document.querySelector('.navigation-search-bar--suggestion-dropdown').classList.add('navigation-suggestion-list-padding');
                if (this.utils.hasClass(document.getElementById('common-hdr-main'), 'navigation-sticky')) {
                    this.utils.addClass(this.bodyEl, 'navigation-prevent-stickyscrolling');
                    this.utils.addClass(document.querySelector('html'), 'navigation-prevent-stickyscrolling');
                } else {
                    this.utils.addClass(this.bodyEl, 'navigation-prevent-scrolling');
                }
                var SearchsuggestionList = document.querySelector('.navigation-search-item--list li');
                var searchbardropdownDiv = document.querySelector('.navigation-search-bar--dropdowndiv');
                if (SearchsuggestionList) {
                    this.utils.addClass(searchbardropdownDiv, 'navigation-scroll-height');
                }

            }
            document.querySelector('.navigation-search-overlay .navigation-search-bar--search-wrap .navigation-search-bar--search').blur();


        },

        setPaddingTop: function () {

            if (this.resetPaddingTop.classList.contains('navigation-suggestion-list-padding')) {
                document.querySelector('.navigation-search-bar--suggestion-dropdown').classList.remove('navigation-suggestion-list-padding');
            }
        },

        removeHeight: function () {

            var searchbardropdownDiv = document.querySelector('.navigation-search-bar--dropdowndiv');
            this.utils.removeClass(searchbardropdownDiv, 'navigation-scroll-height');
        },

        searchOverlayBackgroundClick: function () {
            this.resetSearchText();
            this.hidePopup();
            this.closeSuggestions();
        },

        clearTextSearchOverlayClick: function (evt) {
            evt.stopPropagation();
            evt.preventDefault();
            this.setPaddingTop();
            this.resetSearchText();
            this.removeHeight();
            this.searchContainerParentOverlay.querySelector('.navigation-res-nav-header__dropdown--search .navigation-search-bar--search').focus();
            //call resetSuggestions only after clearing q params so that existing suggestions get cleared
            // No need for this call if the focus() is getting called as it internally calls resetSuggestions
            if (breakpoint.size() !== 'large') {
                document.querySelector('.navigation-search-overlay .navigation-search-bar--search-wrap .navigation-search-bar--search').focus();
            }
            if (breakpoint.size() === 'large') {
                this.formParams.q = '';
                this.resetSuggestions(evt);
            }
        },

        stopKeyStrockTracking: function () {
            window.sessionStorage.removeItem('ks');
        },

        closeSearchOverlayButtonClick: function (evt) {

            evt.stopPropagation();
            evt.preventDefault();
            this.setPaddingTop();
            this.resetSearchText();
            this.removeHeight();

            //call resetSuggestions only after clearing q params so that existing sugggestions get cleared
            this.formParams.q = '';
            this.resetSuggestions(evt);
            this.hidePopup();
            this.closeSuggestions();
        },

        searchAccClose: function (evt) {
            this.setPaddingTop();
            this.resetSearchText();
            this.removeHeight();
            //call resetSuggestions only after clearing q params so that existing sugggestions get cleared
            this.formParams.q = '';
            this.resetSuggestions(evt);
            this.hidePopup();
            this.closeSuggestions();
            if (window.mobileSearchKey) {
                this.dummySearchPanel.focus();
            } else {
                this.searchButton.focus();
            }
        },

        searchOverlayKeyUp: function (evt) {
            if(!window.sessionStorage.getItem('ks') || window.sessionStorage.getItem('ks') === undefined) {
                window.sessionStorage.setItem('ks', '1');
            }

            else {
                var keyStroke = parseInt(window.sessionStorage.getItem('ks'));
                var keyStr = keyStroke + 1 ;
                window.sessionStorage.setItem('ks', keyStr);
            }

            var keyPressed = evt.key || evt.keyCode;
            if (keyPressed === 27 || keyPressed === 'Esc' || keyPressed === 'Escape') {
                window.sessionStorage.removeItem('ks');
                this.setPaddingTop();
                this.resetSearchText();
                this.removeHeight();
                //call resetSuggestions only after clearing q params so that existing suggestions get cleared
                this.formParams.q = '';
                this.resetSuggestions(evt);
                this.hidePopup();
                this.closeSuggestions();
                this.dummySearchPanel.focus();
            }
        },

        dummySearchPanelClick: function (event) {
            event.preventDefault();
            this.showPopup();
            this.openSuggestions();
            event.stopPropagation();
            if (breakpoint.size() !== 'xsmall' && breakpoint.size() !== 'small') {
                for (var topNavItem = 0; topNavItem < this.topNavCheckBox.length; topNavItem++) {
                    this.topNavCheckBox[topNavItem].checked = false;
                }
            }
            this.setValueSearchOverlayInput();

            this.searchContainerParentOverlay.querySelector('.navigation-res-nav-header__dropdown--search .navigation-search-bar--search').focus();
            var suggestionList = document.querySelector('.navigation-search-item--list'),
                recentElement = document.querySelector('.navigation-suggestion-item--title');
            if (breakpoint.size() === 'medium' || breakpoint.size() === 'large') {
                if (recentElement) {
                    this.utils.removeClass(suggestionList, 'navigation-recent-serach-underline');
                }
            }
        },

        dummySearchPanelKeyUp: function (event) {
            var keyPressed = event.key || event.keyCode;
            switch (keyPressed) {
                case 'Enter':
                case ' ':
                case 32:
                case 13:
                    event.preventDefault();
                    this.showPopup();
                    this.openSuggestions();
                    event.stopPropagation();
                    if (breakpoint.size() !== 'xsmall' && breakpoint.size() !== 'small') {
                        for (var topNavItem = 0; topNavItem < this.topNavCheckBox.length; topNavItem++) {
                            this.topNavCheckBox[topNavItem].checked = false;
                        }
                    }
                    this.setValueSearchOverlayInput();

                    this.searchContainerParentOverlay.querySelector('.navigation-res-nav-header__dropdown--search .navigation-search-bar--search').focus();
                    break;
                case 'Escape':
                case 27:
                    this.hidePopup();
                    break;
            }
        },

        searchButtonClick: function (event) {
            event.preventDefault();
            event.stopPropagation();
            this.showPopup();
            this.setValueSearchOverlayInput();
            this.openSuggestions();
            if (breakpoint.size() !== 'xsmall' && breakpoint.size() !== 'small') {
                for (var topNavItem = 0; topNavItem < this.topNavCheckBox.length; topNavItem++) {
                    this.topNavCheckBox[topNavItem].checked = false;
                }
            }
            this.searchContainerParentOverlay.querySelector('.navigation-res-nav-header__dropdown--search .navigation-search-bar--search').focus();
        },

        searchBarFocus: function (evt) {
            if (this.searchBar.value === '') {
                this.formParams.q = '';
            }
            this.resetSuggestions(evt);
        },

        clearElementdeviceClick: function () {
            this.clearRecentSearches();
        },

        clearElementdeviceKeyUp: function (event) {
            var keyPressed = event.key;
            if (keyPressed === 'Enter' || keyPressed === '') {
                this.clearRecentSearches();
            }
        }
    };

    return Search;
});


// WEBPACK FOOTER //
// ./src/mns-core-ui-header/templates/header/js/Search.js